<template>
   <div
        class="company-card"
        :class="{ flipped: isFlipped }"
        @click="toggleCard"
    >
        <div class="company-card-inner">
            <div class="company-card-front">
                <div class="company-card-content">
                    <figure class="company-card-figure">
                        <img :src="location.icon" alt="" class="company-card-logo">
                    </figure>
                    <div class="company-card-tags">
                        <span v-if="location.distance" class="company-card-tag">
                            {{ Number(location.distance).toFixed(2) }} KM
                        </span>
                        <span v-for="(tag, index) in location.tags" :key="`tag-${index}`" class="company-card-tag"
                            :class="'tag-' + formatTagClass(tag)">
                            {{ tag }}
                        </span>
                    </div>
                    <div class="company-card-text">
                        <p>{{ location.teaser_text }}</p>
                    </div>

                    <span class="btn">Adresse anzeigen</span>
                </div>
            </div>
            <div class="company-card-back">
                <span class="company-card-close">✕</span>
                <div class="company-card-address">
                    <h4>{{ translate(translations, 'location.address') }}</h4>
                    <div class="info">
                        <div class="company-name">
                            {{ location.name }}
                        </div>
                        <div class="company-address">
                            {{ location.address }}<br>
                            {{ location.zip }} {{ location.city }}
                        </div>
                    </div>
                </div>
                <div v-if="location.phone" class="phone">
                    <h4>{{ translate(translations, 'location.contact') }}</h4>
                    <div class="info">
                        <a :href="`tel:${location.phone}`">{{ location.phone }}</a>
                    </div>
                </div>
                <div v-if="location.link" class="website">
                    <h4>{{ translate(translations, 'location.website') }}</h4>
                    <div class="info">
                        <a :href="location.link">{{ location.link }}</a>
                    </div>
                </div>
                <div v-if="location.contactFormLink" class="contact-form">
                    <h4>{{ translate(translations, 'location.contactform') }}</h4>
                    <div class="info">
                        <a :href="location.contactFormLink">{{ location.contactFormLink }}</a>
                    </div>
                </div>
                <div v-if="location.customerPortalLink" class="customer-portal">
                    <h4>{{ translate(translations, 'location.customerportal') }}</h4>
                    <div class="info">
                        <a :href="location.customerPortalLink">{{ location.customerPortalLink }}</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
import { ref } from 'vue';
import { translate } from '../translate';

export default {
	name: 'CompanyCards',
	props: {
		location: {
			type: Object,
			required: true,
		},
		iconPath: {
			type: String,
			required: true,
		},
		translations: {
			type: Object,
			required: true,
		},
	},
	setup() {
		const windowWidth = ref(window.innerWidth);
		const expanded = ref(false);

		window.addEventListener('resize', () => {
			windowWidth.value = window.innerWidth;
		});

		const formatTagClass = (tag) => {
			return tag.toLowerCase().replace(/\s+/g, '-');
		};

		const expand = () => {
			expanded.value = !expanded.value;
		};

		return {
			translate,
			expanded,
			expand,
			formatTagClass,
		};
	},
    data() {
        return {
            isFlipped: false
        }
    },
    methods: {
        toggleCard() {
            this.isFlipped = !this.isFlipped
        }
    }
};
</script>